import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _createCompanyProfile(options={}) {
	return _apiRequestWrap(ModulesMap.COMPANY, ModulesConfigMap[ModulesMap.COMPANY].CREATE_COMPANY, options)
}

function _getCompanyProfile(options={}) {
	return _apiRequestWrap(ModulesMap.COMPANY, ModulesConfigMap[ModulesMap.COMPANY].GET_COMPANY, options)
}

function _patchCompanyProfile(options={}) {
	return _apiRequestWrap(ModulesMap.COMPANY, ModulesConfigMap[ModulesMap.COMPANY].PATCH_COMPANY, options)
}

function _getUserCompanyPermission(options={}) {
	return _apiRequestWrap(ModulesMap.COMPANY, ModulesConfigMap[ModulesMap.COMPANY].GET_AVAILABLE_USER_COMPANY_PERMISSIONS, options)
}

export default {
	[ModulesConfigMap[ModulesMap.COMPANY].CREATE_COMPANY]: _createCompanyProfile,
	[ModulesConfigMap[ModulesMap.COMPANY].GET_COMPANY]: _getCompanyProfile,
	[ModulesConfigMap[ModulesMap.COMPANY].PATCH_COMPANY]: _patchCompanyProfile,
	[ModulesConfigMap[ModulesMap.COMPANY].GET_AVAILABLE_USER_COMPANY_PERMISSIONS]: _getUserCompanyPermission,
}
